import React from 'react'
import { Redirect } from 'react-router-dom'
import { FuseUtils } from '@fuse'
import { LoginConfig } from 'app/main/login/LoginConfig'
import { VerifyingRegistrationConfig } from 'app/main/verifyingRegistration/VerifyingRegistrationConfig'
import GroupConfig from 'app/main/group/GroupConfig'
import MaintenanceConfig from 'app/main/maintenance/MaintenanceConfig'
import { SettingsConfig } from 'app/main/settings/SettingsConfig'
import { BeaconConfig } from 'app/main/beacon/BeaconConfig'
// import { MemberCardConfig } from 'app/main/memberCard/MemberCardConfig'
import { DealsPromotionsConfig } from 'app/main/dealsPromotions/DealsPromotionsConfig'
import { Routes } from 'app/services/routeService/routeService'
import SubscribersV4Config from 'app/main/subscribersV4/SubscribersV4Config'
import GroupV4Config from 'app/main/groupV4/GroupV4Config'

import ProfileInfoConfig from 'app/main/profile/ProfileInfoConfig'
import { VerifyingEmailOnPlaceChangingConfig } from 'app/main/verifyingEmailOnPlaceChanging/VerifyingEmailOnPlaceChangingConfig'
import { RedemptionConfig } from 'app/main/redemption/RedemptionConfig'
import { ErrorConfig } from 'app/main/error/ErrorConfig'
import { TopicsConfig } from 'app/main/topics/configs/topicsConfig'
import { IntegrationConfig } from 'app/main/integrations/IntegrationConfig'
import { PlansAndBilliingConfig } from 'app/main/plansAndBilling/PlansAndBillingConfig'
import { MessageConfig } from 'app/main/messages/MessageConfig'
import { IntegrationBeewoConfig } from 'app/main/integrationsBeewo/IntegrationBeewoConfig'
import { ForgotPasswordConfig } from 'app/main/forgotPassword/ForgotPasswordConfig'
import { ResetPasswordConfig } from 'app/main/resetPassword/ResetPasswordConfig'
import { RegisterConfig } from 'app/main/register/RegisterConfig'

const routeConfigs = [
  MessageConfig,
  ProfileInfoConfig,
  GroupConfig,
  MaintenanceConfig,
  SettingsConfig,
  BeaconConfig,
  DealsPromotionsConfig,
  LoginConfig,
  VerifyingRegistrationConfig,
  VerifyingEmailOnPlaceChangingConfig,
  RedemptionConfig,
  ErrorConfig,
  TopicsConfig,
  IntegrationConfig,
  PlansAndBilliingConfig,
  IntegrationBeewoConfig,
  SubscribersV4Config,
  ForgotPasswordConfig,
  GroupV4Config,
  ResetPasswordConfig,
  RegisterConfig,
]

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    component: () => <Redirect to={Routes.notificationTimeline()} />,
  },
]

export default routes
